import { ApiConfig } from '~shared/constants/api.config';
import { environment } from '~env/environment';

export const ACCOUNT_INFO_REQUEST_URL = () => `${ApiConfig.SVC_USER_ACCOUNT_API_URL()}/account-info`;
export const ACCOUNT_INFO_V1_REQUEST_URL = () => `${ApiConfig.SVC_BUYER_API_URL()}/account-info`;
export const ACCOUNT_INFO_V2_REQUEST_URL = () => `${ApiConfig.SVC_BUYER_ACCOUNT_API_V2_URL()}/account/me/full`;

export const IDENTITY_EXCLUDED_URLS = () => [
  environment.cdnBaseUrl(),
  environment.appBaseUrl(), // TODO: should be 'environment.appStaticUrl' but it's value should contain 'static'
  `${ApiConfig.SVC_IMS_API_URL()}/accounts/auth/`,
  ApiConfig.SVC_ACCOUNT_INFO_FLYOUT_REFRESH_ENDPOINT(),
];

// @todo: must be changed to 'core/identity/token'
export const TOKEN_LOCAL_STORAGE_KEY = 'sdk/auth';
export const NOT_AUTHORIZED = 'NOT_AUTHORIZED';
export const USER_TYPE_KEY = 'userType';
export const ACCOUNT_TYPE_KEY = 'accountType';
export const SUB_ACCOUNT_TYPE_KEY = 'subAccountType';
export const IMPERSONATED_CUSTOMER_FULLNAME_KEY = 'IMPERSONATED_CUSTOMER_FULLNAME';
export const PHONE_NUMBER_LOCAL_STORAGE_KEY = '@metromarkets/phoneNumber';
export const HAS_DIGITAL_IDENTITY_KEY = 'hasDigitalIdentity';
export const LOGIN_USER_TYPE_LOCAL_STORAGE_KEY = 'user_type';
export const SESSION_STORAGE_CUSTOMER_CDM_ID_KEY = 'customerCdmId';
export const SESSION_STORAGE_CUSTOMER_BUSINESS_CDM_ID_KEY = 'businessCdmId';
export const EXPONEA_SESSION_UPDATE_LOCAL_STORAGE_KEY = 'exponea_session_update';
export enum LOGIN_USER_TYPES {
  EMPLOYEE = 'EMP',
  CUSTOMER = 'CUST',
}
export const METROMARKETS_IMPERSONATE_BUYER = 'METROMARKETS_IMPERSONATE_BUYER';
export const SUBSIDIARY_INITIAL_REDIRECTION_STATUS = 'SUBSIDIARY_INITIAL_REDIRECTION_STATUS';
export const SUBSIDIARY_SCOPE_CHECKOUT = 'subsidiary_scope_checkout';
export const SOFT_LOGIN_TOKEN_KEY = 'sl-soft-login-token';
